import { logError, useFeatureFlags } from '@chronosphereio/core';

export const CHANGE_EVENTS_UI_MODES = ['enabled', 'disabled', 'read-only'] as const;

export type ChangeEventsUiMode = (typeof CHANGE_EVENTS_UI_MODES)[number];

export function getChangeEventsUiMode(mode: string): ChangeEventsUiMode {
  for (const validMode of CHANGE_EVENTS_UI_MODES) {
    if (validMode === mode) {
      return mode;
    }
  }

  logError(new Error(`Received invalid value '${mode}' for enableChangeEventsUi feature flag`));
  return 'disabled';
}

export function useViewChangeEventsEnabled(): boolean {
  const { enableChangeEventsUi, enableTimelineUI } = useFeatureFlags();
  const value = getChangeEventsUiMode(enableChangeEventsUi);
  return value === 'enabled' || value === 'read-only' || enableTimelineUI;
}

export function useCreateChangeEventsEnabled(): boolean {
  const { enableChangeEventsUi, enableTimelineUI } = useFeatureFlags();
  return getChangeEventsUiMode(enableChangeEventsUi) === 'enabled' || enableTimelineUI;
}
